import React, { useEffect } from 'react';
import { useTranslations } from '../../localization/useTranslations';

export default function EmailValidationNavigator() {
  const [isEmailVerified, setIsEmailVerified] = React.useState(
    window.crm_user?.user?.email_validated_at ? true : false
  );
  const translations = useTranslations();
  const myAccountSlug = window.myAccountPageSlug || 'my-account';

  const handleRouteChange = () => {
    const emailVerified = !!window.crm_user?.user?.email_validated_at;
    setIsEmailVerified(emailVerified);

    if (emailVerified) {
      window.removeEventListener('popstate', handleRouteChange);
    }
  };

  window.addEventListener('popstate', handleRouteChange);

  const navigateToEmailValidation = () => {
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/${myAccountSlug}/#/email-validation/`;
    // set the current url as the redirect url
    localStorage.setItem('redirect_url', window.location.href);
    window.location.replace(url);
  };

  useEffect(() => {
    setIsEmailVerified(window.crm_user?.user?.email_validated_at ? true : false);
  }, []);

  return (
    <>
      {!isEmailVerified && (
        <button
          onClick={() => {
            navigateToEmailValidation();
          }}
          className="my-account-nav__greeting-link button-text button button--secondary button--medium"
        >
          {translations?.authLabels?.validateEmail || 'Verify your email'}
        </button>
      )}
    </>
  );
}
